import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'
import {
  skuManagementApiRoutes,
  uploadApiRoutes,
  poTrendsApiRoutes,
  createShouldCostApiRoutes,
  commodityApiRoutes,
  viewShouldCostApiRoutes,
  configurationPageApiRoutes,
  currencyApiRoutes,
} from '../constants/serviceConstants/shouldCostAIBased.apiRoutes'

export const getFiltersDataAsync = createAsyncThunk(
  'should-cost-ai-based/should-cost-get-filter-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuManagementApiRoutes.getFilters, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getKpisAsync = createAsyncThunk(
  'should-cost-ai-based/should-cost-get-kpis-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuManagementApiRoutes.getKPIs, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSkuTableDataAsync = createAsyncThunk(
  'should-cost-ai-based/should-cost-get-sku-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuManagementApiRoutes.getSkuTable, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getTotalSKUCountAsync = createAsyncThunk(
  'should-cost-ai-based/should-cost-get-sku-total-pages',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuManagementApiRoutes.getTotalSKUCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//upload sku master file
export const validateFileUploadsync = createAsyncThunk(
  'shouldCostAIBased/uploadTemplate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', uploadApiRoutes.validateFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
//finish upload sku master file
export const fileUploadAsync = createAsyncThunk(
  'shouldCostAIBased/finishUploadTemplate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', uploadApiRoutes.uploadFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
// download sku master and po standard template
export const downloadFileTemplateAsync = createAsyncThunk(
  'shouldCostAIBased/downloadFileTemplate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', uploadApiRoutes.downloadFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getViewShouldCostDataAsync = createAsyncThunk(
  'should-cost-ai-based/get-should-cost-models-by-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', uploadApiRoutes.getShouldCostModelsBySku, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const setShouldCostFinalAsync = createAsyncThunk(
  'should-cost-ai-based/set-should-cost-final',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', uploadApiRoutes.setModelFinal, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get PO Trends Data for SKUs
export const getPOTrendsDataAsync = createAsyncThunk(
  'shouldCostAIBased/poTrendsData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', poTrendsApiRoutes.getTrendsData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get PO Trends Line Chart Data for SKUs
export const getPOTrendsLineChartDataAsync = createAsyncThunk(
  'shouldCostAIBased/poTrendsLineChartData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', poTrendsApiRoutes.getTrendsLineChartData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCreateViewDataAsync = createAsyncThunk(
  'shouldCostAIBased/createShouldCostView',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes.getCreateShouldCostView, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const createShouldCostModelDataAsync = createAsyncThunk(
  'shouldCostAIBased/createShouldCostModel',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes.createShouldCostModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const editShouldCostModelDataAsync = createAsyncThunk(
  'shouldCostAIBased/editShouldCostModel',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes.editShouldCostModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get Commodity data
export const getCommodityDataAsync = createAsyncThunk(
  'shouldCostAIBased/commodity-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', commodityApiRoutes.commodityData, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get Countries data
export const getCountriesDataAsync = createAsyncThunk(
  'shouldCostAIBased/getCountriesData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', createShouldCostApiRoutes.getCountries, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get Should Cost Model data
export const getShouldCostModelsByFiltersAsync = createAsyncThunk(
  'shouldCostAIBased/getShouldCostModelsByFiltersAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes.getShouldCostModels, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getMaxDateAsync = createAsyncThunk(
  'shouldCostAIBased/getMaxDateData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', createShouldCostApiRoutes.getMaxDate, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get Should Cost Breakdown
export const getShouldCostBreakdownDataAsync = createAsyncThunk(
  'shouldCostAIBased/getShouldCostBreakdownData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      createShouldCostApiRoutes.getShouldCostBreakdownForModel,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Get Commodity KPIs
export const getCommodityKPIsAsync = createAsyncThunk(
  'shouldCostAIBased/commodity-kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', commodityApiRoutes.commodityKPIs, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get mini ifa trendline

export const getIfaTrendsLineChartDataAsync = createAsyncThunk(
  'shouldCostAIBased/poTrendsLineChartData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.trendLine, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//check for mini ifa calculation
export const checkIfaProgressAsync = createAsyncThunk(
  'shouldCostAIBased/checkIfaProgressAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.checkIfaProgress, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Download should Cost
export const downloadShouldCostAsync = createAsyncThunk(
  'shouldCostAIBased/downloadShouldCost',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.downloadShouldCost, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get files attached to Model
export const attachedModelFilesAsync = createAsyncThunk(
  'shouldCostAIBased/attachedModelFilesData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.attachFilesToModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get sku related urls
export const getSkuAttachmentsAsync = createAsyncThunk(
  'shouldCostAIBased/getSkuAttachmentsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes.getSkuAttachments, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
//download sku related urls
export const downloadSkuFileAsync = createAsyncThunk(
  'shouldCostAIBased/downloadSkuFile',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes.downloadSkuFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAllVendorsForSkuAsync = createAsyncThunk(
  'shouldCostAIBased/get-all-vendors-for-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.getAllVendorsForSku, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAllVendorsForSkuByModelAsync = createAsyncThunk(
  'shouldCostAIBased/get-all-vendors-for-sku-by-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.getAllVendorsForSkuByModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getChartCostSummaryDetails = createAsyncThunk(
  'shouldCostAIBased/get-chart-cost-summary-details-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.getChartCostSummaryDetails, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getBillOfMaterialDetails = createAsyncThunk(
  'shouldCostAIBased/get-bill-of-material-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.getBillOfMaterialDetails, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Configuration Label Page
export const getSkuConfigurationDataAsync = createAsyncThunk(
  'shouldCostAIBased/get-config-labels-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', configurationPageApiRoutes.getSkuLabelConfig, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const setConfigurationDataAsync = createAsyncThunk(
  'shouldCostAIBased/set-config-labels-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', configurationPageApiRoutes.setSkuLabelConfig, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getShouldCostBreakdownDetailsAsync = createAsyncThunk(
  'shouldCostAIBased/get-should-cost-model-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', viewShouldCostApiRoutes.getShouldCostBreakdownDetails, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCurrencyExchangeRateAsync = createAsyncThunk(
  'shouldCostAIBased/get-currency-exchange-rate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', currencyApiRoutes.getCurrencyExchangeRate, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get taxonomy model categories
export const getCategoriesTaxonomyAsync = createAsyncThunk(
  'shouldCostAIBased/get-standard-taxonomy',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes?.getStandardTaxonomy, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get model meta data
export const getModelMetaDataAsync = createAsyncThunk(
  'shouldCostAIBased/get-model-meta-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', createShouldCostApiRoutes?.getModelMetaData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get dpcd data
export const getDpcdDataAsync = createAsyncThunk(
  'sku-management/get-dpcs-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuManagementApiRoutes.getDpcdData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)